export function sendWithBeacon(url, payload) {
  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.sendBeacon === 'function'
  ) {
    const blob = new Blob([JSON.stringify(payload)], {
      type: 'application/json',
    });
    const sent = navigator.sendBeacon(url, blob);
    if (sent) {
      return true;
    }
  }

  if (typeof fetch !== 'undefined') {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  }

  return false;
}
